// extracted by mini-css-extract-plugin
module.exports = {"fork_alert":"ForkAlert_fork_alert__33jj4"};